var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gs"},[_c('MainContent',{attrs:{"softwareInfo":_vm.softwareInfo}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }